<template>
  <v-container v-if="template">
    <v-card flat color="transparent">
      <v-card-text>
        <InventoryRecordViewer
          ref="inventoryRecordViewer"
          :loading="loading"
          :template.sync="template.templates"
          :edit="true"
        ></InventoryRecordViewer>
      </v-card-text>
    </v-card>
    <v-row align="center" justify="end" no-gutters class="mt-3">
      <v-btn color="success" @click="save">
        <v-icon small left>fa-save</v-icon>
        Enregistrer
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { InventoryRecordViewer } from "../components";
export default {
  name: "InventoryTemplateEditor",
  components: {
    InventoryRecordViewer
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  async beforeRouteLeave(to, from, next) {
    if (this.changed === true) {
      const res = await this.$dialog.confirm({
        text:
          "Voulez-vous enregistrer les modifications avant de quitter la page?",
        title: "",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      this.changed = false;
      if (res === true) {
        await this.save();
      }
    }
    next();
  },
  computed: {
    ...mapGetters(["getIsAdmin", "getStoreId", "getInventoryTemplate"])
  },
  data() {
    return {
      loading: false,
      template: undefined,
      changed: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.$store.dispatch("slo");
        await Promise.all([
          this.$store.dispatch("loadTagCategories"),
          this.$store.dispatch("loadInventoryTagOrders"),
          this.$store.dispatch("loadProducts")
        ]);
        const res = await this.$store.dispatch("loadInventoryTemplates");
        if (res) {
          this.template = res;
          this.changed = false;
        } else {
          this.template = {
            name: "Inventaire",
            is_default: true,
            is_deleted: false,
            store: this.getStoreId,
            templates: []
          };
        }
      } finally {
        this.loading = false;
        this.$store.dispatch("elo");
      }
    },
    async save() {
      try {
        this.$store.dispatch("slo");
        if (this.template.id !== undefined && this.template.id !== null) {
          await api.putInventoryTemplate(this.template.id, this.template);
        } else {
          await api.postInventoryTemplate(this.template);
        }
        await this.$refs.inventoryRecordViewer.saveOrder();
        this.changed = false;
        this.$router.push({ name: "InventoryIndex" });
      } finally {
        this.$store.dispatch("elo");
      }
    },
    changeHandler(nV, oV) {
      if (oV !== undefined && oV !== null) {
        this.changed = true;
      }
    }
  },
  watch: {
    template: {
      deep: true,
      handler: "changeHandler"
    }
  }
};
</script>

<style></style>
